import React, {useEffect, useState} from 'react';
import SignInCard from "./SignInCard";
import Typography from "../../../components/Typography";
import styles from "./home.module.scss";
import SignupModal from "./SignupModal";
import {useLocation} from "react-router-dom";
import {useSelector} from "react-redux";
import withAuthRoutes from "../../../hoc/withAuthRoutes";
import TFA from "./2FA";

const Home = () => {
    const {search} = useLocation()
    const params = new URLSearchParams(search);
    const {forgotPasswordModal, openAuthenticatorModal} = useSelector(state => state.auth)
    let invite = params.has("token")
    const authFlow = invite ? "invite" : forgotPasswordModal
    const [showGabiText, setShowGabiText] = useState(true)
    useEffect(() => {
        setTimeout(() => {
            setShowGabiText(!showGabiText)
        }, 2000)
    }, [])
    return (
        <div className={"container px-2 mx-auto"}>
            <div className="md:grid md:grid-cols-5 gap-x-1 xl:gap-x-24">
                <div className={"md:col-span-3"}>
                    <div className={`mt-4 sm:mt-24 hlg:mt-10 ${styles.heading}`}>
                        <Typography variant={"h2"} className={"text-white xs:text-2xl"}>Meaningful, Scalable &
                            Repeatable
                            Pentesting.</Typography>
                        <Typography variant={"h4"} className={"text-white mt-3 sm:mt-5 xs:text-xl"}>Now at your
                            fingertips!</Typography>
                    </div>
                </div>
                <div className="md:col-span-2">
                    <SignInCard/>
                </div>
            </div>
            <div className={styles.bottom}>
                <div className={"md:grid md:grid-cols-5 xl:gap-x-24"}>
                    <div className={"md:col-span-3"}>
                        {/*<Typography variant={"h6"} className={"mt-3 sm:mt-0 pb-4 md:pb-9"}>Brands that trust*/}
                        {/*    us</Typography>*/}
                        {/*<div className={styles.brands}>*/}
                        {/*    <img src="/images/brands/deloitte.png" alt=""/>*/}
                        {/*    <img src="/images/brands/accenture.png" className={"ml-9"} alt=""/>*/}
                        {/*    <img src="/images/brands/insent.png" className={"ml-9"} alt=""/>*/}
                        {/*    <img src="/images/brands/difference_card.png" className={"ml-9"} alt=""/>*/}
                        {/*    <img src="/images/brands/match_book.png" className={"ml-9"} alt=""/>*/}
                        {/*</div>*/}
                    </div>
                    {/* <div className={"md:col-span-2 fixed md:static bottom-[45px] right-[20px] left-[10px] z-[999]"}>
                        <div className={styles.amora}>
                            <div className={styles.content}>
                                <div className={`${styles.chat} ${showGabiText && styles.active}`}>
                                    <Typography variant={"subtitle1"} className={"font-semibold text-primary-800 mb-1"}>Hi!
                                        I
                                        am Gabi <span className={"text-base"}>&#128075;</span></Typography>
                                    <Typography variant={"body2"}>I am the customer success Manager at Siemba. I’ll be
                                        your guide throughout your journey</Typography>
                                </div>
                                <img onClick={() => setShowGabiText(!showGabiText)} src="/images/gabi.png" alt=""/>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
            {Boolean(authFlow) && <SignupModal open={true}/>}
            {openAuthenticatorModal && <TFA/>}
        </div>
    );
};

export default withAuthRoutes(Home);
